import { HotelAmenitySchema as DomainHotelAmenitySchema } from '@voll-intelligence/domain';
import { z } from 'zod';

/**
 * Comodidade no wire: o `code` do catálogo (quando o modal-session reconheceu o
 * id do fornecedor) e o texto do fornecedor como `label`. O card só faz
 * `code → chave de i18n`; nada aqui é inferido do texto.
 *
 * A forma é a do domínio, não uma cópia: só o `preprocess` é daqui, porque é a
 * migração de replay. Até 2026-08-07 o campo era `string[]` com o texto cru, e
 * um bloco persistido daquela época tem de continuar parseando. String vira
 * `{ label }` — sem `code`, então aparece no idioma em que foi gravada, que é
 * exatamente o que já acontecia.
 */
export const HotelAmenitySchema = z.preprocess(
  (value) => (typeof value === 'string' ? { label: value } : value),
  DomainHotelAmenitySchema,
);
export type ChatUiHotelAmenity = z.infer<typeof HotelAmenitySchema>;
